export type TwilioCallStatus =
  | "connecting"
  | "ringing"
  | "connected"
  | "disconnected"
  | "failed"
  | "incoming"
  | "answered_elsewhere";

export interface TwilioVoiceToken {
  token: string;
  identity: string;
  expiresAt: Date;
}

export interface TwilioCallEvent {
  type: TwilioCallStatus;
  call?: any; // Twilio Call object
  error?: string;
  /** Incoming call metadata (populated for "incoming" events) */
  from?: string;
  to?: string;
  /** Twilio CallSid (populated for "incoming" and "answered_elsewhere" events) */
  callSid?: string;
}

export type TwilioCallEventListener = (event: TwilioCallEvent) => void;
